import { render } from "./Footer.vue?vue&type=template&id=8035590e"
const script = {}
script.render = render

export default script